import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ICON } from '@core/util/icon';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { TitlePlusService } from '@services/title-plus/title-plus.service';
import { AuthState } from '@state/auth';
import { environment } from 'src/environments/environment';
import {
	TitlePlusLsnComponent,
	TitlePlusLsnComponentData,
} from './title-plus-lsn/title-plus-lsn.component';
import { Select } from '@ngxs/store';
import { TitlePlusState } from '@state/global/title-insurance/title-plus/title-plus.state';
import { ConnectedUser } from '@state/llc/llc.model';
import { AuthUser } from '@state/auth/auth.models';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { envTypes } from 'src/environments/env.types';
import LogRocket from 'logrocket';
import { TestHooks } from './title-plus-profile.hooks';

enum ACTIONS {
	CONNECT = 'connect',
}

enum COLUMNS {
	ACTION = 'action',
	INITIALS = 'initials',
	NAME = 'name',
	STATUS = 'status',
	LSN = 'lsn',
}

@UntilDestroy()
@Component({
	selector: 'app-title-plus-profile',
	templateUrl: './title-plus-profile.component.html',
	styleUrls: ['./title-plus-profile.component.scss'],
	standalone: false,
})
export class TitlePlusProfileComponent implements OnInit {
	testHooks = TestHooks;
	public connected = false;
	public loading = true;
	public ICON = ICON;
	public callbackUrl = environment.titlePlus.callBackUrl;
	public clientId = environment.titlePlus.clientId;
	public encodedCallbackUrl = encodeURIComponent(this.callbackUrl);
	public link = `${environment.titlePlus.lawProUrl}/v1/authorize?client_id=${this.clientId}&redirect_uri=${this.encodedCallbackUrl}&response_type=code&state=`;

	ACTIONS = ACTIONS;
	COLUMNS = COLUMNS;
	displayedColumns: COLUMNS[] = [
		COLUMNS.INITIALS,
		COLUMNS.NAME,
		COLUMNS.LSN,
		COLUMNS.STATUS,
		COLUMNS.ACTION,
	];

	@SelectSnapshot(AuthState.getUserId) userId: string;
	@Select(AuthState.getLoggedInUser) user$: Observable<AuthUser>;
	@Select(TitlePlusState.connectedLawyers) lawyers$: Observable<
		ConnectedUser[]
	>;

	constructor(
		private activatedRoute: ActivatedRoute,
		private titlePlusService: TitlePlusService,
		private dialog: MatDialog,
	) {}

	ngOnInit(): void {
		this.activatedRoute.queryParams
			.pipe(untilDestroyed(this))
			.subscribe((params) => {
				const code = params['code'];
				const userId = params['state'];
				if (code) {
					this.exchangeAuthorizationCodeForTokens(code, userId);
				}
			});
	}

	private exchangeAuthorizationCodeForTokens(
		code: string,
		userId: string,
	): void {
		this.titlePlusService.exchangeCodeForToken(code, userId).subscribe(
			(res: any) => {
				if (environment.env === envTypes.PRODUCTION) {
					LogRocket.log('Exchanging TitlePLUS auth code for tokens res', res);
				} else {
					console.log('res', res);
				}
				if (res.access_token) {
					this.loading = false;
					this.connected = true;
				}
			},
			(err: any) => {
				console.log('err', err);
			},
		);
	}

	manageLSNs(userId?: string): void {
		const data: TitlePlusLsnComponentData = {
			userId,
		};
		this.dialog.open(TitlePlusLsnComponent, { data });
	}
}
